import React from 'react';
import useViewPortWidth from '../../hooks/useViewportWidth';
import CartModal from './cartModal';
import CartModalMobile from './MobileView/cartModalMobile';

const CartHome = (props) => {
  const viewportWidth = useViewPortWidth();

  return (
    <>
      {viewportWidth > 500 ? (
        <CartModal {...props} />
      ) : (
        <CartModalMobile
          show={props.show}
          handleClose={props.handleClose}
          handleCreateOrder={props.handleCreateOrder}
          isLoadingModal={props.isLoadingModal}
        />
      )}
    </>
  );
};

export default CartHome;
